export default __webpack_public_path__ + "static/media/benutzerIconLight.12c60a36.svg";